import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { connectionApi } from '../../lib/connections-api';
import styles from './Connections.module.css';
export interface InstructionsProposal {
  version: number;
  connectionId: string;
  expectedRevision: number;
  instructions: string;
}
export function ConnectionInstructionsCard({
  proposal,
}: {
  proposal: InstructionsProposal;
}) {
  const [text, setText] = useState(proposal.instructions),
    [revision, setRevision] = useState(proposal.expectedRevision),
    [cancelled, setCancelled] = useState(false);
  const cache = useQueryClient();
  const save = useMutation({
    mutationFn: () =>
      connectionApi.patch(proposal.connectionId, {
        expectedRevision: revision,
        instructions: text,
      }),
    onSuccess: () => {
      void cache.invalidateQueries({ queryKey: ['connection'] });
      void cache.invalidateQueries({ queryKey: ['navigation-status'] });
    },
  });
  const reload = useMutation({
    mutationFn: () => connectionApi.detail(proposal.connectionId),
    onSuccess: (c) => setRevision(c.revision),
  });
  if (cancelled) return <p>Instruction proposal dismissed.</p>;
  if (save.isSuccess) return <p>Saved connection instructions.</p>;
  return (
    <section className={styles.card}>
      <strong>Proposed connection instructions</strong>
      <textarea
        aria-label="Proposed instructions"
        maxLength={8000}
        value={text}
        onChange={(e) => setText(e.target.value)}
      />
      <p className={styles.muted}>
        Guidance does not change connection permissions.
      </p>
      <div className={styles.row}>
        <button disabled={save.isPending} onClick={() => save.mutate()}>
          Save to connection instructions
        </button>
        <button onClick={() => setCancelled(true)}>Cancel</button>
      </div>
      {save.isError && (
        <p role="alert">
          {save.error.message}{' '}
          <button disabled={reload.isPending} onClick={() => reload.mutate()}>
            Load latest revision and keep this text
          </button>
        </p>
      )}
      {reload.isError && <p role="alert">{reload.error.message}</p>}
    </section>
  );
}
